import { LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@/auth/hooks/useAuth';
import {
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/common/components/ui/dropdown-menu';

export default function ProfileDropdownMenu() {
  const { logout } = useAuth();
  const { t } = useTranslation('auth');

  const handleLogout = async () => {
    await logout();
  };

  return (
    <DropdownMenuContent
      align="end"
      className="border-none"
      sideOffset={8}
      style={{ width: 'var(--radix-dropdown-menu-trigger-width)' }}
    >
      <DropdownMenuItem
        onClick={handleLogout}
        className="cursor- text-terre-800 focus:bg-warm-gray-100 focus:text-terre-800"
      >
        <LogOut className="mr-2 h-4 w-4" />
        <span>{t('logout.button')}</span>
      </DropdownMenuItem>
    </DropdownMenuContent>
  );
}
